var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49991 8.25C9.49991 9.04565 9.81598 9.80871 10.3786 10.3713C10.9412 10.9339 11.7043 11.25 12.4999 11.25C13.2956 11.25 14.0586 10.9339 14.6212 10.3713C15.1838 9.80871 15.4999 9.04565 15.4999 8.25C15.4999 7.45435 15.1838 6.69129 14.6212 6.12868C14.0586 5.56607 13.2956 5.25 12.4999 5.25C11.7043 5.25 10.9412 5.56607 10.3786 6.12868C9.81598 6.69129 9.49991 7.45435 9.49991 8.25Z",
    stroke: "#8790A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.75V17.25C8 16.4544 8.31607 15.6913 8.87868 15.1287C9.44129 14.5661 10.2044 14.25 11 14.25H14C14.7956 14.25 15.5587 14.5661 16.1213 15.1287C16.6839 15.6913 17 16.4544 17 17.25V18.75",
    stroke: "#8790A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIc);
export default __webpack_public_path__ + "static/media/person-ic.d8badef590af69a5545eb2a0910b4cf3.svg";
export { ForwardRef as ReactComponent };